import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './routes';
// import { store } from '@/modules/wms/stores'; // Vuex Store importieren
import { registerSW } from 'virtual:pwa-register';
import { useAuthStore } from '@/modules/auth/stores/authStore';

import 'bootstrap'; // Hier importieren wir das Bootstrap JavaScript

import { library } from '@fortawesome/fontawesome-svg-core';

import { faWindows } from '@fortawesome/free-brands-svg-icons';

import {
  faArrowDownLong,
  faArrowsLeftRight,
  faArrowRight,
  faArrowRightFromBracket,
  faArrowRightToBracket,
  faArrowsRotate,
  faArrowUpLong,
  faBarcode,
  faBars,
  faBolt,
  faBox,
  faBoxOpen,
  faBoxesPacking,
  faBoxesStacked,
  faCertificate,
  faChartArea,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faCircleXmark,
  faClipboard,
  faCube,
  faEnvelope,
  faExclamationTriangle,
  faFile,
  faFileDownload,
  faFileInvoice,
  faFloppyDisk,
  faGear,
  faGlobe,
  faLayerGroup,
  faList,
  faListCheck,
  faMagnifyingGlass,
  faMagnifyingGlassPlus,
  faMap,
  faMinus,
  faPallet,
  faPaperPlane,
  faPen,
  faPenToSquare,
  faPlus,
  faPrint,
  faPuzzlePiece,
  faRotate,
  faRuler,
  faRulerCombined,
  faTableCells,
  faTableColumns,
  faTag,
  faTags,
  faTrash,
  faUsers,
  faUsersViewfinder,
  faWandMagicSparkles,
  faWarehouse,
  faWeightScale,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faArrowDownLong,
  faArrowsLeftRight,
  faArrowRight,
  faArrowRightFromBracket,
  faArrowRightToBracket,
  faArrowsRotate,
  faArrowUpLong,

  faBarcode,
  faBars,
  faBolt,
  faBox,
  faBoxOpen,
  faBoxesPacking,
  faBoxesStacked,

  faCertificate,
  faChartArea,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faCircleXmark,
  faClipboard,
  faCube,

  faEnvelope,
  faExclamationTriangle,

  faFile,
  faFileDownload,
  faFileInvoice,
  faFloppyDisk,

  faGear,
  faGlobe,

  faLayerGroup,
  faList,
  faListCheck,

  faMagnifyingGlass,
  faMagnifyingGlassPlus,
  faMap,
  faMinus,

  faPallet,
  faPaperPlane,
  faPen,
  faPenToSquare,
  faPlus,
  faPrint,
  faPuzzlePiece,

  faRotate,
  faRuler,
  faRulerCombined,

  faTableCells,
  faTableColumns,
  faTag,
  faTags,
  faTrash,

  faUsers,
  faUsersViewfinder,

  faWandMagicSparkles,
  faWarehouse,
  faWeightScale,
  faWindows,
  faXmark
);

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

registerSW({ immediate: true });

async function bootstrap() {
  const app = createApp(App);
  app.use(createPinia());

  // app.use(store); // Vuex Store einbinden, solange Vuex noch verwendet wird

  app.use(router);
  app.component('font-awesome-icon', FontAwesomeIcon);

  const auth = useAuthStore();
  await auth.initAuth();

  if (!auth.isAuthenticated) {
    auth.login();
  }

  app.mount('#app');
}

bootstrap();
